import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, mergeMap, Observable, of, switchMap } from 'rxjs';
import { Action } from '@ngrx/store';
import {
  ComplianceSummaryActions,
  ComplianceSummaryAPIActions,
} from '../actions/compliance-summary.actions';
import { ComplianceHttpService } from '../../http/compliance/compliance-http.service';

@Injectable()
export class ComplianceSummaryEffects {
  public loadComplianceSummary$: Observable<Action> = createEffect(() =>
    this._actions$.pipe(
      ofType(ComplianceSummaryActions.loadComplianceSummary),
      switchMap(() =>
        this._complianceHttpService.complianceSummary$.pipe(
          mergeMap((complianceSummary) =>
            of(
              ComplianceSummaryAPIActions.loadedComplianceSummarySuccessfully({
                complianceSummary,
              }),
            ),
          ),
          catchError((error) =>
            of(
              ComplianceSummaryAPIActions.loadedComplianceSummaryUnsuccessfully(
                { error },
              ),
            ),
          ),
        ),
      ),
    ),
  );

  constructor(
    private _actions$: Actions,
    private _complianceHttpService: ComplianceHttpService,
  ) {}
}
